import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { CompliancePatientRow } from "../../models/patient-reports/election-on-file-gap";
import { ConfigurationService } from "../configuration/configuration.service";

// CO-3429 — UI-side data path for the Medi-Cal election-on-file gap surfaced on
// the compliance dashboard.
//
// Reads the per-tenant Medi-Cal-primary election-on-file gap rows from the
// patient-benefits API (GET /patient-benefits/compliance/election-on-file/tenant/{orgId},
// backed by NewElectionOnFileGapRows in patient-benefits-functions, INFO severity).
// The base path is `patient-benefits` to match the deployed API base-path mapping
// (same prefix the existing patient-benefits.service.ts uses), NOT the source-tree
// name `patient-benefits-functions`. The compliance-report page derives display via
// `shouldSurfaceElectionOnFileGap`, keeping the CompliancePatientRow contract.
@Injectable()
export class ComplianceGapService {
  private readonly apiUrl: string;

  constructor(
    public http: HttpClient,
    private config: ConfigurationService
  ) {
    this.apiUrl = config.getConfig().apiUrl;
  }

  /**
   * Fetch the per-patient compliance rows for a tenant. Each row carries the
   * `mediCalPrimary` / `hasElectionOnFile` flags the dashboard needs to derive
   * the election-on-file gap. Returns an Observable — the page subscribes.
   */
  getElectionOnFileGaps(orgId: number): Observable<CompliancePatientRow[]> {
    const url = `${this.apiUrl}/patient-benefits/compliance/election-on-file/tenant/${orgId}`;
    return this.http.get<CompliancePatientRow[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/providers/compliance-gap-service/compliance-gap-service.ts